import React, { ReactNode } from 'react';

import { Branch } from './Branch';
import { Braze } from './Braze';
import { OneTrust } from './OneTrust';
import { Segment } from './Segment';
import { Split } from './Split';

interface TelemetryProps {
  children: ReactNode;
}

const Telemetry = ({ children }: TelemetryProps) => (
  <>
    <Segment />
    <Branch>
      <Braze>
        <Split>
          <OneTrust />
          {children}
        </Split>
      </Braze>
    </Branch>
  </>
);

export { Telemetry };
